(()=>{
  const roots=document.querySelectorAll('#BotanicalDescription,.ob-reference-about,.ob-aplus__rich');
  const clean=value=>value.replace(/\b\d{3,}_[A-Za-z][A-Za-z0-9_]*\b/g,code=>code.replace(/^\d+_/, '').replace(/_/g,' ').replace(/steel lemon squeez\b/i,'Steel Lemon Squeezer'));
  roots.forEach(root=>{
    root.querySelectorAll('tr').forEach(row=>{
      const label=row.querySelector('th,td')?.textContent.trim().toLowerCase()||'';
      if(/^sku\s*: ?$/.test(label)||label==='sku')row.remove();
    });
    const walker=document.createTreeWalker(root,NodeFilter.SHOW_TEXT);
    let node;
    while((node=walker.nextNode())){
      if(node.parentElement.closest('script,style,textarea'))continue;
      node.textContent=clean(node.textContent);
    }
  });
})();
